export default "/83f713f8a255736a91a641f899cdd549.jpg";